export enum OperationTypeEnum {
    Add = 0,
    Edit = 1,
    Delete = 2,
    Mention = 3,
    Comment = 4,
    InitialAssigned = 5,
    AssignedUpdate = 6,
    Reparent = 7,
    Lock = 8,
    Unlock = 9,

}

export enum CrudOperationEnum {
  Create = 0,
  Read = 1,
  Update = 2,
  Delete = 3
}

export enum BaseEntityEnum {
  Account = 0,
  Appointment = 1,
  Group = 2,
  Category = 3,
  Communication = 4,
  Customer = 5,
  Post = 6,
  Comment = 7,
  Job = 8,
  Snippet = 9,
  Quote = 10,
  PaymentLink = 11,
  Attachment = 12,
  Search = 13,
}
